import {
    Box,
    VStack,
} from '@chakra-ui/react';
import React from 'react';
import { ReportedFindingsMachineContext } from '../../machine/context';
import { ReportedFindingsWizardRowHeader } from './reported-findings-wizard-row';
import { RequestQuoteWizardRow } from './request-quote-wizard-row';
import { ReportedFindingsWizardSkeleton } from './reported-findings-wizard-table';

export function RequestQuoteWizardTable({
    rowGridWrapper,
}: {
    rowGridWrapper?: React.ComponentType<{ children: React.ReactNode }>;
}) {
    const reportedFindings = ReportedFindingsMachineContext.useSelector(
        (state) => state.context.reportedFindings
    );

    return (
        <VStack alignItems="flex-start" spacing={4} mt={8}>
            <Box w="full">
                <ReportedFindingsWizardRowHeader />
            </Box>

            {reportedFindings == null && (<ReportedFindingsWizardSkeleton />)}

            <VStack spacing={4} w="full">
                {reportedFindings?.map((item) => (
                    <RequestQuoteWizardRow
                        key={`${item.problemRegister.problemRegisterId}`}
                        reportedFinding={item}
                        gridWrapper={rowGridWrapper}
                    />
                ))}
            </VStack>
        </VStack>
    );
}
